'use client';
import { Text, VStack } from '@chakra-ui/react';

import { goTo } from 'shared/lib';

import { DEFAULT_BORDER, DEFAULT_BORDER_RADIUS, HEADER_HEIGHTS } from 'constants/global';

const TableOfContents = ({ navButtonsData }) => (
  <VStack
    w="full"
    maxW={{ laptop: '332px', desktop: '364px' }}
    h="fit-content"
    pos="sticky"
    top={HEADER_HEIGHTS}
    align="start"
    p="32px"
    gap="24px"
    border={DEFAULT_BORDER}
    borderColor="line.gray"
    borderRadius={DEFAULT_BORDER_RADIUS}
    bg="rgba(255, 255, 255, 0.40)"
    backdropFilter="blur(20px)"
  >
    <Text textStyle="header.h4" fontSize={{ mobile: '24px', desktop: '32px' }}>
      Содержание
    </Text>

    <VStack
      w="full"
      align="start"
      gap="8px"
      color="text.steelGray"
      // @ts-ignore
      onClick={e => goTo(e.target.dataset.goToElement)}
    >
      {navButtonsData.map(({ title, elementGoTo }) => (
        <Text
          key={elementGoTo}
          data-go-to-element={elementGoTo}
          cursor="pointer"
          fontSize={{ mobile: '18px', laptop: '20px', desktop: '24px' }}
          py="8px"
          _hover={{ color: 'text.black' }}
        >
          {title}
        </Text>
      ))}
    </VStack>
  </VStack>
);

export default TableOfContents;
